import React from "react";
import PreviewWrapper from "../component/PreviewWrapper";
import HeaderDownload from "../component/download/HeaderDownload";
import BodyDownload from "../component/download/BodyDownload";
import { useLocation } from "react-router-dom";

function PreviewPage({ schedules, listType, selectedClub, selectedStudio }) {
  // function PreviewPage() {
  const location = useLocation();
  // const { schedules, listType, selectedClub, selectedStudio } = location.state || {};

  // console.log({ schedules, listType, selectedClub, selectedStudio });
  return (
    <div className="preview-page">
      <PreviewWrapper scale={1}>
        <div className="mx-2">
          <HeaderDownload selectedClub={selectedClub} selectedStudio={selectedStudio} />
          <div className="" style={{ marginTop: "100px" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <BodyDownload schedules={schedules} />
            </div>
            <div
              className="d-flex justify-content-center flex-wrap"
              style={{
                overflowX: "hidden",
                minWidth: "max-content",
                maxHeight: "100px",
                justifyContent: "center",
              }}
            >
              {listType?.map(
                (type, idx) =>
                  type.id !== "" && (
                    <div className="me-2" key={idx}>
                      <div
                        className={`mb-3 button-category`}
                        style={{
                          width: "auto",
                          fontWeight: "600",
                          background: `${type.id ? "#ffffff" : "transparent"}`,
                        }}
                      >
                        {type.id ? (
                          <i
                            className="bi bi-bookmark-fill me-2"
                            style={{ fontSize: "0.7rem", color: type.bg_color }}
                          ></i>
                        ) : (
                          <></>
                        )}
                        {type.id !== "" ? <span>{type?.name}</span> : <></>}
                      </div>
                    </div>
                  )
              )}
            </div>
          </div>
        </div>
      </PreviewWrapper>
    </div>
  );
}

export default PreviewPage;
